module.exports = __webpack_public_path__ + "img/modal-top.be82e5cc.png";